import { render, staticRenderFns } from "./GroupRoomType.vue?vue&type=template&id=538b0fe0"
import script from "./GroupRoomType.vue?vue&type=script&lang=js"
export * from "./GroupRoomType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports